<template>
  <section class="layout-section -bg-shade -no-top">
    <div class="layout-section__hgroup -bigger">
      <h2 v-scroll:reveal class="layout-section__title">Revue Apprendre + Agir</h2>
    </div>

    <section v-if="$wp.apprendreAgirPosts" v-scroll:reveal class="slider" :style="{ '--height': `${sizes.height}px` }">
      <TransitionGroup :name="transitionName" tag="div" class="card-article">
        <a
          v-for="entry in publications"
          :key="entry.id"
          ref="card"
          :href="entry.link"
          target="_blank"
          rel="noopener noreferrer"
          class="card-article__item slider__item"
          :style="{ '--width': `${sizes.width}px`, '--height': `${sizes.height}px` }"
        >
          <div class="card-article__figure" :style="{ backgroundImage: `url('/images/brand/placeholder.png')` }">
            <figure
              v-if="entry.image"
              class="card-article__image"
              :style="{ backgroundImage: `url('${entry.image}')` }"
            />
          </div>

          <section class="card-article__content -global">
            <div class="card-article__uptitle">
              <div class="card-article__data">
                <SvgIcon id="content-date" />
                <p>{{ getFormattedDate(entry.date) }}</p>
              </div>

              <div class="card-article__data">
                <SvgIcon id="time" />
                <p>{{ getReadingTime(entry.content) }} min</p>
              </div>
            </div>

            <h4 class="card-article__title" v-html="entry.title" />
          </section>
        </a>
      </TransitionGroup>

      <div v-if="hasPrevPublication || hasNextPublication" class="slider__controls">
        <button
          v-if="hasPrevPublication"
          class="slider__button -prev"
          aria-label="Afficher nouvelle précédente"
          @click="onClickPrev"
        >
          <SvgIcon id="arrow" class="-reverse" />
        </button>

        <button
          v-if="hasNextPublication"
          class="slider__button -next"
          aria-label="Afficher prochaine nouvelle"
          @click="onClickNext"
        >
          <SvgIcon id="arrow" />
        </button>
      </div>
    </section>

    <div v-scroll:reveal class="layout-section__controls">
      <a
        href="https://icea-apprendreagir.ca/"
        target="_blank"
        rel="noopener noreferrer"
        class="button layout-section__cta"
      >
        Voir la revue Apprendre + Agir
        <SvgIcon id="action-arrow" />
      </a>
    </div>
  </section>
</template>

<script>
import moment from 'moment'
import { getReadingTime } from '@/helpers/content-formatting'

export default {
  name: 'HomeApprendreAgir',
  data() {
    return {
      startIndex: 0,
      transitionName: 'slider__item-next',
      sizes: {
        width: 0,
        height: 'auto'
      }
    }
  },
  computed: {
    itemCount() {
      const phoneCount = this.$device.phoneH ? 2 : 1
      return this.$device.laptop ? 3 : phoneCount
    },
    allPublications() {
      return this.$wp.apprendreAgirPosts || []
    },
    publications() {
      return this.allPublications.slice(this.startIndex, this.startIndex + this.itemCount)
    },
    hasNextPublication() {
      return this.startIndex + this.itemCount < this.allPublications.length
    },
    hasPrevPublication() {
      return this.startIndex > 0
    }
  },
  watch: {
    publications: {
      immediate: true,
      handler() {
        this.$nextTick(() => {
          if (!this.$refs.card || !this.$refs.card.length) return
          const [firstCard, secondCard] = this.$refs.card
          const card = secondCard || firstCard
          this.sizes.width = card.offsetWidth
          this.sizes.height = card.offsetHeight || 'auto'
        })
      }
    },
    '$wp.apprendreAgirPosts': {
      handler(newVal) {
        if (newVal) console.log('Apprendre + Agir:', newVal)
      },
      immediate: true
    }
  },
  methods: {
    getFormattedDate(date) {
      return date ? moment(date).format('D MMMM YYYY') : null
    },
    getReadingTime(content = '') {
      const [readingContent] = content.split('<strong>Références</strong>')
      return getReadingTime(readingContent)
    },
    onClickNext() {
      if (this.hasNextPublication) {
        this.transitionName = 'slider__item-next'
        this.startIndex++
      }
    },
    onClickPrev() {
      if (this.hasPrevPublication) {
        this.transitionName = 'slider__item-prev'
        this.startIndex--
      }
    }
  }
}
</script>
